var _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStoreIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "App_Store_Icon",
    "data-name": "App Store Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.48,
    height: 28.455,
    viewBox: "0 0 92.48 28.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M189.121,960.435a3.972,3.972,0,0,1-4.087,3.846h-84.3a3.973,3.973,0,0,1-4.088-3.846V939.67a3.973,3.973,0,0,1,4.088-3.845h84.3a3.972,3.972,0,0,1,4.087,3.845Z",
    transform: "translate(-96.641 -935.825)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(6.203 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M149.55,1000.3a14.991,14.991,0,0,1-1.354,2.528c-.88,1.339-2.119,3.006-3.655,3.021-1.365.012-1.716-.889-3.568-.878s-2.239.894-3.6.882c-1.536-.014-2.711-1.52-3.59-2.859-2.46-3.744-2.716-8.138-1.2-10.474a5.442,5.442,0,0,1,4.377-2.632c1.628,0,2.651.893,4,.893,1.306,0,2.1-.894,3.983-.894a5.312,5.312,0,0,1,4,2.114A4.582,4.582,0,0,0,149.55,1000.3Z",
    transform: "translate(-131.637 -985.005)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(8.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M183.47,965.739a4.569,4.569,0,0,0,1.015-3.384,4.937,4.937,0,0,0-3.187,1.714,4.242,4.242,0,0,0-1.041,3.3A4.166,4.166,0,0,0,183.47,965.739Z",
    transform: "translate(-180.207 -962.355)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345",
    transform: "translate(28.086 3.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(0 7.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M258.605,1004.42l-3.523,10.371H256.7l1.052-3.185h3.411l1.082,3.185H263.9l-3.538-10.371Zm.836,1.705c.119.463.247.944.412,1.463l.949,2.75h-2.7l.936-2.768C259.179,1007.121,259.315,1006.637,259.441,1006.125Z",
    transform: "translate(-255.082 -1004.255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M312.006,1019.586a2.935,2.935,0,0,0-2.494,1.2l-.063-1.031h-1.435l.008.132c.042.643.06,1.35.06,2.365v7.994h1.569v-3.73a2.756,2.756,0,0,0,2.145.922,3.235,3.235,0,0,0,2.377-1.011,4.286,4.286,0,0,0,1.05-3.018,4.173,4.173,0,0,0-.911-2.756A2.985,2.985,0,0,0,312.006,1019.586Zm-.391,1.3c1.4,0,2.025,1.3,2.025,2.58,0,1.656-.8,2.685-2.084,2.685a1.9,1.9,0,0,1-1.848-1.456,2,2,0,0,1-.056-.508v-1.262a2.362,2.362,0,0,1,.05-.387c.008-.043.016-.086.022-.127A1.987,1.987,0,0,1,311.615,1020.885Z",
    transform: "translate(-298.631 -1016.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M357.588,1019.586a2.937,2.937,0,0,0-2.495,1.2l-.063-1.031H353.6l.008.132c.043.643.06,1.35.06,2.365v7.994h1.569v-3.73a2.754,2.754,0,0,0,2.144.922,3.239,3.239,0,0,0,2.379-1.011,4.292,4.292,0,0,0,1.049-3.018,4.173,4.173,0,0,0-.912-2.756A2.984,2.984,0,0,0,357.588,1019.586Zm-.391,1.3c1.4,0,2.024,1.3,2.024,2.58,0,1.656-.8,2.685-2.084,2.685a1.9,1.9,0,0,1-1.848-1.456,2,2,0,0,1-.055-.508v-1.262a2.326,2.326,0,0,1,.05-.388c.008-.042.016-.085.023-.126A1.986,1.986,0,0,1,357.2,1020.885Z",
    transform: "translate(-336.133 -1016.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M415.88,1008.047c-1.464-.567-1.934-1.013-1.934-1.837,0-.694.551-1.394,1.783-1.394a3.567,3.567,0,0,1,1.842.463l.133.082.443-1.309-.088-.051a4.548,4.548,0,0,0-2.285-.513c-2,0-3.4,1.181-3.4,2.872,0,1.364.875,2.317,2.754,3,1.332.5,1.827,1.008,1.827,1.881,0,.989-.765,1.6-1.994,1.6a4.294,4.294,0,0,1-2.261-.641l-.136-.087-.421,1.34.078.051a5.374,5.374,0,0,0,2.652.682c2.7,0,3.653-1.644,3.653-3.052C418.527,1009.685,417.76,1008.789,415.88,1008.047Z",
    transform: "translate(-384.304 -1003.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M451.71,1010.439l-1.539.483v1.3h-1.126v1.254h1.126v3.841a2.936,2.936,0,0,0,.543,1.991,2.011,2.011,0,0,0,1.518.6,3.7,3.7,0,0,0,1.213-.187l.088-.031-.075-1.256-.15.046a2.37,2.37,0,0,1-.73.084c-.608,0-.868-.384-.868-1.288v-3.8H453.6v-1.254H451.71Z",
    transform: "translate(-414.663 -1009.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M479.39,1019.586a3.7,3.7,0,0,0-3.728,3.984,3.58,3.58,0,0,0,3.608,3.864h.015a3.7,3.7,0,0,0,3.728-4,3.964,3.964,0,0,0-1-2.775A3.491,3.491,0,0,0,479.39,1019.586Zm-.045,1.239c1.411,0,2.054,1.376,2.054,2.655,0,1.573-.877,2.714-2.084,2.714H479.3c-1.19,0-2.054-1.123-2.054-2.669C477.246,1022.181,477.9,1020.825,479.345,1020.825Z",
    transform: "translate(-436.562 -1016.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M526.117,1019.659l-.094-.024a1.512,1.512,0,0,0-.39-.049,2.238,2.238,0,0,0-1.967,1.263l-.046-1.1h-1.408l.009.132c.042.621.059,1.318.059,2.259l-.015,5.126h1.569v-4a4.036,4.036,0,0,1,.043-.608,1.734,1.734,0,0,1,1.651-1.581,4.047,4.047,0,0,1,.421.026l.168.018Z",
    transform: "translate(-474.859 -1016.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M547.678,1019.5c-2.089,0-3.547,1.669-3.547,4.059a3.509,3.509,0,0,0,3.7,3.789,6.02,6.02,0,0,0,2.484-.477l.094-.043-.3-1.169-.131.053a4.862,4.862,0,0,1-1.966.351,2.181,2.181,0,0,1-2.35-2.275l5.064.015.02-.1a3.487,3.487,0,0,0,.047-.655C550.791,1021.414,549.976,1019.5,547.678,1019.5Zm-.1,1.194a1.548,1.548,0,0,1,1.152.439,2.234,2.234,0,0,1,.541,1.461h-3.579A2,2,0,0,1,547.574,1020.7Z",
    transform: "translate(-492.894 -1016.663)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M255.082,963.983a11.443,11.443,0,0,1,1.5-.1,3.358,3.358,0,0,1,2.209.6,2.148,2.148,0,0,1,.777,1.77,2.484,2.484,0,0,1-.785,1.908,3.641,3.641,0,0,1-2.419.707,10.894,10.894,0,0,1-1.287-.059Zm.712,4.348a5.062,5.062,0,0,0,.712.029c1.5.007,2.322-.757,2.322-2.083.008-1.172-.72-1.893-2.209-1.893a4.464,4.464,0,0,0-.825.065Z",
    transform: "translate(-255.082 -963.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M285.941,975.125a1.769,1.769,0,0,1-1.877-1.813,1.818,1.818,0,0,1,1.942-1.872,1.755,1.755,0,0,1,1.885,1.806,1.825,1.825,0,0,1-1.942,1.879Zm.024-.481a1.254,1.254,0,0,0,1.19-1.376,1.2,1.2,0,1,0-1.2,1.376Z",
    transform: "translate(-278.927 -969.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M308.628,971.891l.526,1.784c.1.393.21.765.283,1.129h.024c.089-.357.219-.735.348-1.121l.639-1.792h.6l.607,1.762c.145.415.259.794.348,1.151h.024a9.759,9.759,0,0,1,.3-1.143l.558-1.77h.7l-1.262,3.525h-.647l-.6-1.682a11.536,11.536,0,0,1-.348-1.165h-.016a9.687,9.687,0,0,1-.356,1.173l-.631,1.675h-.647l-1.182-3.525Z",
    transform: "translate(-298.537 -970.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M343.861,972.474c0-.371-.008-.662-.033-.954h.631l.04.576h.016a1.483,1.483,0,0,1,1.295-.656,1.341,1.341,0,0,1,1.384,1.5v2.1h-.711v-2.032c0-.568-.235-1.048-.907-1.048a1.016,1.016,0,0,0-.954.655.862.862,0,0,0-.049.3v2.126h-.712Z",
    transform: "translate(-328.097 -969.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M369.346,962.607h.712v5.17h-.712Z",
    transform: "translate(-349.091 -962.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M380.309,975.125a1.769,1.769,0,0,1-1.877-1.813,1.818,1.818,0,0,1,1.942-1.872,1.755,1.755,0,0,1,1.885,1.806,1.825,1.825,0,0,1-1.942,1.879Zm.024-.481a1.254,1.254,0,0,0,1.19-1.376,1.2,1.2,0,1,0-1.2,1.376Z",
    transform: "translate(-356.567 -969.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M406.423,974.2a5.306,5.306,0,0,0,.057.845h-.64l-.065-.444h-.024a1.506,1.506,0,0,1-1.2.524,1.068,1.068,0,0,1-1.2-1.012c0-.852.841-1.318,2.354-1.311v-.073c0-.291-.089-.823-.89-.815a2.042,2.042,0,0,0-1.028.262l-.162-.43a2.757,2.757,0,0,1,1.295-.306,1.31,1.31,0,0,1,1.5,1.442Zm-.7-.954c-.777-.015-1.659.109-1.659.794a.6.6,0,0,0,.664.612.987.987,0,0,0,.963-.59.588.588,0,0,0,.033-.2Z",
    transform: "translate(-377.074 -969.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M429.161,962.607v4.26c0,.313.009.67.032.91h-.639l-.032-.612h-.016a1.465,1.465,0,0,1-1.327.692,1.681,1.681,0,0,1-1.683-1.792,1.757,1.757,0,0,1,1.756-1.893,1.347,1.347,0,0,1,1.182.532h.016v-2.1Zm-.712,3.08a1.063,1.063,0,0,0-.032-.276,1.029,1.029,0,0,0-1.027-.736,1.206,1.206,0,0,0-1.173,1.355,1.169,1.169,0,0,0,1.157,1.31,1.06,1.06,0,0,0,1.044-.765,1,1,0,0,0,.032-.277Z",
    transform: "translate(-395.288 -962.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M462.8,975.125a1.769,1.769,0,0,1-1.877-1.813,1.818,1.818,0,0,1,1.942-1.872,1.755,1.755,0,0,1,1.886,1.806,1.825,1.825,0,0,1-1.942,1.879Zm.024-.481a1.254,1.254,0,0,0,1.189-1.376,1.2,1.2,0,1,0-1.2,1.376Z",
    transform: "translate(-424.433 -969.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M487.431,972.474c0-.371-.008-.662-.033-.954h.631l.041.576h.016a1.483,1.483,0,0,1,1.295-.656,1.341,1.341,0,0,1,1.384,1.5v2.1h-.712v-2.032c0-.568-.234-1.048-.906-1.048a1.017,1.017,0,0,0-.955.655.87.87,0,0,0-.048.3v2.126h-.712Z",
    transform: "translate(-446.217 -969.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M521.387,967.127v.844h1.019v.488h-1.019v1.9c0,.437.138.685.534.685a1.462,1.462,0,0,0,.413-.044l.032.488a2.136,2.136,0,0,1-.631.088,1.078,1.078,0,0,1-.769-.269,1.28,1.28,0,0,1-.275-.925v-1.922h-.607v-.488h.607v-.648Z",
    transform: "translate(-473.109 -966.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M537.705,962.607h.712v2.2h.016a1.208,1.208,0,0,1,.51-.452,1.5,1.5,0,0,1,.728-.182,1.34,1.34,0,0,1,1.367,1.507v2.1h-.712v-2.024c0-.575-.235-1.049-.906-1.049a1.023,1.023,0,0,0-.955.641.7.7,0,0,0-.049.306v2.126h-.712Z",
    transform: "translate(-487.607 -962.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M562.131,973.357a1.194,1.194,0,0,0,1.335,1.224,2.968,2.968,0,0,0,1.085-.175l.13.451a3.5,3.5,0,0,1-1.311.226,1.737,1.737,0,0,1-1.926-1.777,1.794,1.794,0,0,1,1.845-1.908,1.543,1.543,0,0,1,1.61,1.661,1.477,1.477,0,0,1-.024.306Zm2.08-.459a.946.946,0,0,0-.979-1.042,1.108,1.108,0,0,0-1.092,1.042Z",
    transform: "translate(-507.137 -969.84)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIconWhite);
export default __webpack_public_path__ + "static/media/app-store-icon-white.37f41687b33217cef4e10bd919ccb9ad.svg";
export { ForwardRef as ReactComponent };